import { render, staticRenderFns } from "./HistoryDynamicBloodGlucose2.vue?vue&type=template&id=ac54d470&scoped=true&"
import script from "./HistoryDynamicBloodGlucose2.vue?vue&type=script&lang=js&"
export * from "./HistoryDynamicBloodGlucose2.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDynamicBloodGlucose2.vue?vue&type=style&index=0&id=ac54d470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac54d470",
  null
  
)

export default component.exports